"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KYCLevel = void 0;
var KYCLevel;
(function (KYCLevel) {
    KYCLevel["Light"] = "LIGHT";
    KYCLevel["Regular"] = "REGULAR";
})(KYCLevel || (exports.KYCLevel = KYCLevel = {}));
//# sourceMappingURL=KYCLevel.js.map